module.exports = __webpack_public_path__ + "img/20200609_115431.7053fa3d.jpg";